"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
const icons_core_1 = require("@volkswagen-onehub/icons-core");
const react_1 = __importDefault(require("react"));
const icon_button_1 = require("./icon-button");
function CloseButton({ ariaLabel, onClick, className }) {
    return (react_1.default.createElement(icon_button_1.IconButton, { ariaLabel: ariaLabel, onClick: onClick, className: className },
        react_1.default.createElement(icons_core_1.Close, { variant: "default" })));
}
exports.CloseButton = CloseButton;
